<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="ch00_fm06_toc"><a id="page_vii"></a>Contents</h2>
<p class="toc"><a class="nounder" href="#/xhtml/ch00_fm07_ack#ch00_fm07_ack"><em>Acknowledgments</em></a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ch00_fm08_pre#ch00_fm08_pre"><em>Preface</em></a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ch00_fm09_int#ch00_fm09_int">Introduction: Marriage Promotion, Heterosexuality, and “Being American”</a></p>
<p class="toc1"><a class="nounder" href="#/xhtml/ch01#ch01">1 Unite! Marriage and American Identity</a></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample">2 The Stakes of Gender and Heterosexuality</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">3 Widening the Marriage Gap</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">4 Teaching Marriage to Single Mothers and Inmates</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">5 Marriage Recitals in High School</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">6 Contesting Native American Marriage</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch07_con#ch07_con" title="Link target outside of Sample">Conclusion: The Power of the “M-Word”</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch08_app_a#ch08_app_a" title="Link target outside of Sample"><em>Appendix A: Methods</em></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch09_app_b#ch09_app_b" title="Link target outside of Sample"><em>Appendix B: Sample Characteristics: In-depth Interviews of Participants in Workshops for the General Population</em></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch10_notes#ch10_notes" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch11_bib#ch11_bib" title="Link target outside of Sample"><em>Bibliography</em></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch12#ch12" title="Link target outside of Sample"><em>Index</em></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch13_abo#ch13_abo" title="Link target outside of Sample"><em>About the Author</em></span><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm06_toc.vue?2d16bb15